import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

const StatusIcon = {
  title: 'Components/Icon/Status Icon',
  component: 'a1-status-icon',
  argTypes: {
    size: {
      // Rearrange the order of the options
      options: ['s', 'm'],
      control: { type: 'select' },
    },
  },
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component:
          'A list of available icons can be found [here](https://ndbx.azurewebsites.net/allianz-icons/prod/index.html).',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-status-icon';

const Template = (args: Components.A1StatusIcon): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Critical: Story<Components.A1StatusIcon> = Template.bind({});
Critical.args = {
  type: 'critical',
};

export const Info: Story<Components.A1StatusIcon> = Template.bind({});
Info.args = {
  type: 'info',
};

export const Positive: Story<Components.A1StatusIcon> = Template.bind({});
Positive.args = {
  type: 'positive',
};

export const Warning: Story<Components.A1StatusIcon> = Template.bind({});
Warning.args = {
  type: 'warning',
};

export default StatusIcon;
